import Vue from 'vue';

export default {
  data() {
    return {
      mediaFiles: [],
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    bufferLabel() {
      return this.$store.state.buffer ? this.$store.state.buffer.label : '';
    },
    notReader() {
      return !this.$store.getters.isReader;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isDispatcher() {
      return this.$store.getters.isDispatcher;
    },
  },
  methods: {
    goEdit() {
      if (this.$route.name === 'resultView') {
        this.$router.push(`/foundedit/${this.id}`);
      } else if (this.id[0] === 'c') { // case TODO
        this.$router.push(this.$route.path.replace('c/', 'cedit/'));
      } else {
        this.$router.push(`/listedit/${this.id}`);
      }
    },
    chooseMedia() {
      this.$refs.mediaModal.open();
    },
    mediaDeleted(data) {
      console.log('mediaDeleted', data);
      const unitToSave = this.$copy(this.id[0] === 'c' ? this.$store.state.cases[this.id] : this.$store.state.units[this.id]);
      const ind = unitToSave.medias.findIndex(item => item.id === data.id);
      if (ind > -1) {
        const it = this;
        unitToSave.medias.splice(ind, 1);
        this.$store.dispatch('saveUnit', unitToSave)
          .then(() => it.$store.dispatch('deleteUnit', data.id)) // delete from local db
          .catch((err) => {
            console.log('mediaDeleted error', err);
          });
      }
    },
    doNext() { // process next mediaFile
      console.log('Do Next, media left -- ', this.mediaFiles.length);
      if (this.mediaFiles[0]) {
        this.$refs.mediator.init(this.mediaFiles.shift(), true, this.mediaFiles.length);
      }
    },
    mediaEdited(mediaData) { // save edited media data
      const data = this.$copy(mediaData);
      console.log('mediaEdited', data);
      const unitToSave = this.$copy(this.id[0] === 'c' ? this.$store.state.cases[this.id] : this.$store.state.units[this.id]);
      if (data.contentType) { // new media
        if (unitToSave.medias && unitToSave.medias[0]) {
          unitToSave.medias.push(data);
        } else {
          unitToSave.medias = [data];
        }
      } else { // existing media
        const ind = unitToSave.medias.findIndex(item => item.id === data.id);
        if (ind > -1) {
          Object.assign(unitToSave.medias[ind], data);
        }
      }
      this.$store.dispatch('saveUnit', unitToSave)
        .then(() => {
          console.log('Unit Media saved');
        })
        .catch((err) => {
          console.log('mediaEdited error', err);
        });
    },
    showAttach(media) {
      console.log('showAttach', media);
      this.$refs.mediator.init(media, false);// edit=false
    },
    createAttach(e) { // start after click on button Добавить вложение -> Фото и т.п.
      console.log('start createAttach', e);
      if (e.coords) { // Место
        const map = {
          name: '',
          comment: '',
          dND: false,
          file: null,
          contentType: 'geo',
        };
        const lat = e.coords.latitude;
        const lng = e.coords.longitude;
        map.mapInfo = {
          place: { lat, lng },
          center: { lat, lng },
          zoom: 12,
        };
        Vue.nextTick(() => {
          this.$refs.mediator.init(map, true);// edit=true
        }, this);
      } else { // Документ Фото Видео или Аудио
        if (e.target.files.length > 10) {
          this.$store.commit('pushError', {
            error: 'Слишком много файлов!',
            message: 'Не более 10 штук',
          });
        }
        const files = Array.from(e.target.files).slice(0, 10);
        this.mediaFiles = [];
        console.log('createAttach', files);
        files.forEach((f) => {
          if (f.size > 50 * 1024 * 1024) {
            this.$store.commit('pushError', {
              error: 'Слишком большой файл!',
              message: `${f.name}\nОбъем файла не должен превышать 50МБ`,
            });
          } else {
            const m = { file: f };
            m.contentType = f.type || e.target.accept;// sometimes f.type not defined
            this.mediaFiles.push(m);
          }
        });
        if (this.mediaFiles[0]) {
          Vue.nextTick(() => {
            this.$refs.mediator.init(this.mediaFiles.shift(), true, this.mediaFiles.length); // init by first file (edit=true)
            e.target.value = ''; // reset
          }, this);
        }
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/view-common.js